module.exports = __webpack_public_path__ + "static/media/mono_manual_schematic_patch_1.f2b346db.svg";